import React from 'react';
import { ButtonV2, styled, keyframes } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

type GuestIdentificationStickyButtonProps = Readonly<{
  onClick: () => void;
}>;

const slideInFromBottom = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, calc(100% + 2rem));
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
`;

const StickyContainer = styled.div`
  position: fixed;
  left: 50%;
  bottom: 1.5rem;
  transform: translate(-50%, 0);
  z-index: 50;
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  background-color: white;
  border-radius: 9999px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  animation: ${slideInFromBottom} 350ms cubic-bezier(0.2, 0.9, 0.3, 1) both;
  animation-delay: 200ms;
`;

export const GuestIdentificationStickyButton: React.FC<GuestIdentificationStickyButtonProps> = ({ onClick }) => {
  const { tq } = useTranslation('guestUnlock');

  return (
    <StickyContainer>
      <ButtonV2
        shape="rounded"
        intent="neutral"
        onClick={onClick}
      >
        {tq`Find your invitation`}
      </ButtonV2>
    </StickyContainer>
  );
};
